


































































import Vue from "vue";

export default Vue.extend({
  name: "Bubble",
  components: {},
  props: {
    r: Number,
    x: Number,
    y: Number,
    points: String,
    depth: Number,
    number: Number,
    content: String,
    start_gradient: String,
    end_gradient: String,
    stroke: String,
  },
  data() {
    return {
      yVal: this.y,
      time: 0,
      phase: Math.random() * 30 * Math.PI,
      period: 90 / (10 + this.depth),
      amplitude: this.depth / 3,
      stroke2: this.stroke,
    };
  },
  mounted() {
    // requestAnimationFrame(this.tick);
  },
  methods: {
    tick() {
      this.time += 1;
      this.yVal +=
        0.5 *
        this.amplitude *
        Math.sin((this.time * 0.5) / this.period + this.phase);
      requestAnimationFrame(this.tick);
    },
    gradient() {
      return "url(#" + this.number + ")";
    },
  },
});
